import LoopWins from "slotworks/state-machine/standard/states/loop-wins";
import gameState from "slotworks/model/game-state";
import G288SpinRecord from "integration/spin-record";
import soundManager from "slotworks/sound/sound-manager";
import WayResult from "integration/builders/way-result";
import { UnlockSymbols } from "commands/symbols-commands";
import Components from "slotworks/components/components";

export default class G288LoopWins extends LoopWins {

    public onEnter() {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        if(record.results.length == 1 && record.timesCycled < 1 && record.results[0] instanceof WayResult) {
            record.timesCycled++; // start from 1 to avoid hearing symbol sounds 2 times for 1 type of symbol win
        }
        UnlockSymbols(Components.matrix.getGridSymbols());
        super.onEnter();
    }

    public onExit() {
        const record = gameState.getCurrentGame().getCurrentRecord() as G288SpinRecord;
        if(record && record.timesCycled > 1) {
            soundManager.customEvent("base_music");
        }
        super.onExit();
    }

}


// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/states/loop-wins.ts